(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('regionsController', regionsController)
        .controller('newRegionController', newRegionController)
        .controller('editRegionController', editRegionController)
        .controller('deleteRegionController', deleteRegionController);

    regionsController.$inject = ['linkService', 'tabs', 'regions'];
    newRegionController.$inject = ['linkService', 'tabs', 'countries', 'regionService'];
    editRegionController.$inject = ['linkService', 'tabs', 'countries', 'region', 'regionId', 'regionService'];
    deleteRegionController.$inject = ['regionId', 'region', 'regionService', '$uibModalInstance'];

    function regionsController(linkService, tabs, regions){
        var vm = this;
        vm.pages = [];
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.regions = (regions.data._embedded.regions) ? regions.data._embedded.regions : [];
        vm.pages = regions.data.page;
    }

    function newRegionController(linkService, tabs, countries, regionService){
        var vm = this;
        vm.countryId = '';
        vm.tabs = tabs;
        vm.countries = countries;
        vm.region = {};
        vm.linkService = linkService;
        vm.isDisabled = false;

        vm.onCountry = function () {
            if(vm.region.country !== undefined) {
                vm.countryId = linkService.getLinkId(vm.region.country._links.self.href);
            }
        }

        vm.saveRegion = function(isValid, region){
            if (isValid) {
                var saveForm = {
                    "countryId": parseInt(linkService.getLinkId(region.country._links.self.href)),
                    "initial": region.initials,
                    "name": region.name
                }
                regionService.saveRegion(saveForm);
            }
        };
    }

    function editRegionController(linkService, tabs, countries, region, regionId, regionService){
        var vm = this;
        vm.tabs = tabs;
        vm.countries = countries;
        vm.region = {
            'country': region.data._embedded.country,
            'name': region.data.name,
            'initials': region.data.initial
        };
        vm.old = angular.copy(vm.region);
        vm.buttonSave = true;
        vm.isDisabled = true;

        vm.countryId = vm.region.country._links.self.href ? linkService.getLinkId(vm.region.country._links.self.href) : '';
        vm.linkService = linkService;

        vm.onCountry = function () {
            if(vm.region.country !== undefined) {
                vm.countryId = linkService.getLinkId(vm.region.country._links.self.href);
            }
        }

        vm.saveRegion = function(isValid, region){
            if (isValid) {
                var saveForm = {
                    "countryId": parseInt(linkService.getLinkId(region.country._links.self.href)),
                    "initial": region.initials,
                    "name": region.name
                }
                regionService.updateRegion(saveForm, regionId);
            }
        };

        vm.change = function(){
            if(vm.region.country!=undefined&&vm.region.country.name==vm.old.country.name &&
               vm.region.name.toUpperCase()==vm.old.name.toUpperCase() && vm.region.initials==vm.old.initials){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteRegionController(regionId, region, regionService, $uibModalInstance){
        var vm = this;
        vm.region = region.data;

        vm.deleteRegion = function(){
            regionService.deleteRegion(regionId)
                .then(function(){
                    $uibModalInstance.close(true);
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
